/** Sensitivity API endpoints, merged into the platform API client. */
export const sensitivityApiEndpoints: Record<string, string> = {
  sensitivity: "/ext/sensitivity/:kind/:pk/",
  sensitivityLevels: "/ext/sensitivity/levels/:kind/",
  setSensitivity: "PUT:/ext/sensitivity/:kind/:pk/",
  sensitivityHold: "/ext/sensitivity/hold/:pk/",
  setSensitivityHold: "PUT:/ext/sensitivity/hold/:pk/",
};
